import { api } from 'api'
import { format } from 'date-fns'
import { LogEventType } from 'api/company'

export interface CompanyWorkerLog {
  timestamp: string
  message: string
  userId: number
  eventType: LogEventType
}

const logDateFormat = "yyyyMMdd'T'HH:mm:ssx"

export async function getCompanyWorkerLogs(options: {
  companyId: number
  startDate: Date
  endDate: Date
  userId: number
}) {
  const { companyId, startDate, endDate, userId } = options
  const response = await api.post<{
    eventLogs: CompanyWorkerLog[]
  }>(`/company/graphql_dispatch/${companyId}/company_worker_logs_7f70e3ee`, {
    startsAt: startDate ? format(startDate, logDateFormat) : undefined,
    endsAt: endDate ? format(endDate, logDateFormat) : undefined,
    userId,
  })

  return response.data.eventLogs
}
